import Vue from 'vue'
import Router from 'vue-router'
import store from './store/store'

import Customers from './views/Customers.vue'
import Organizations from './views/Organizations.vue'
import Overview from './views/Overview.vue'
import Playground from './views/Playground.vue'
import Prospects from './views/Prospects.vue'
import Reports from './pages/Reports'
import Reviews from './views/Reviews.vue'
import Search from './views/Search.vue'
import Settings from './views/Settings.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'overview',
      component: Overview,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/customers',
      name: 'customers',
      component: Customers,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/organizations/:orgId',
      name: 'organizations',
      component: Organizations,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/playground',
      name: 'playground',
      component: Playground,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/prospects',
      name: 'prospects',
      component: Prospects,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/reports',
      name: 'reports',
      component: Reports,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/reviews',
      name: 'reviews',
      component: Reviews,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/search',
      name: 'search',
      component: Search,
      props: route => ({ query: route.query.q }),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/settings',
      name: 'settings',
      component: Settings,
      meta: {
        requiresAuth: true
      }
    },
    // redirect unknown routes
    {
      path: '*',
      redirect: '/'
    }
  ]
})

router.beforeEach((to, from, next) => {
  const isLoggedIn = store.getters['user/isLoggedIn']
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)

  if (requiresAuth && !isLoggedIn) {
    store.dispatch('user/login')
  } else {
    next()
  }
})

export default router
